import { Injectable, inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { QuickCreateHandler, QuickCreatePayload } from '@libs/util-services';
import { QuickCreateModalComponent } from './quick-create-modal.component';

/**
 * Implementação do QUICK_CREATE_HANDLER. Quando o usuário clica em célula
 * vazia (day/week view), abre o `QuickCreateModalComponent` com os dados
 * pré-preenchidos (data, hora, quadra, duração, preço sugerido).
 *
 * O modal dispatch `addUnusualPeriod` e dismiss com `{ created: true }`
 * quando o backend confirma. Aqui mostramos um toast de sucesso e retornamos
 * o flag pro `calendar-agenda-page` recarregar a agenda.
 */
@Injectable({ providedIn: 'root' })
export class QuickCreateService implements QuickCreateHandler {
  private readonly modalCtrl = inject(ModalController);
  private readonly toastCtrl = inject(ToastController);

  async open(payload: QuickCreatePayload): Promise<{ created: boolean }> {
    const modal = await this.modalCtrl.create({
      component: QuickCreateModalComponent,
      componentProps: { payload },
      cssClass: 'quick-create-modal',
      backdropDismiss: true,
      showBackdrop: true,
    });
    await modal.present();

    const { data } = await modal.onWillDismiss<{ created?: boolean }>();
    const created = data?.created === true;

    if (created) {
      const successToast = await this.toastCtrl.create({
        message: `Horário especial criado: ${payload.slotTime} em ${payload.courtName ?? `quadra ${payload.courtId}`}`,
        duration: 3500,
        position: 'bottom',
        color: 'success',
      });
      await successToast.present();
    }

    return { created };
  }
}
